var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path13, _rect7, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 146,
    viewBox: "0 0 170 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M105.658 61.9197C97.2882 61.9197 88.7682 61.5797 80.7982 59.3597C72.9782 57.1897 65.7982 52.9797 59.3982 48.1097C55.2082 44.9397 51.3982 42.4197 45.9582 42.7997C40.6318 43.0913 35.5406 45.0899 31.4382 48.4997C24.5182 54.4997 25.5582 65.7297 28.3282 73.6197C32.4882 85.4997 45.1482 93.7297 55.9082 99.1097C68.3382 105.32 81.9982 108.92 95.6882 111C107.688 112.82 123.108 114.15 133.508 106.31C143.058 99.1097 145.678 82.6697 143.338 71.5697C142.771 68.2876 141.025 65.3255 138.428 63.2397C131.718 58.3397 121.708 61.6097 114.168 61.7797C111.368 61.8397 108.518 61.9097 105.658 61.9197Z",
    fill: "url(#paint0_linear_6178_28808)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1787 130.447C105.453 130.447 121.889 129.422 121.889 128.157C121.889 126.892 105.453 125.867 85.1787 125.867C64.9044 125.867 48.4688 126.892 48.4688 128.157C48.4688 129.422 64.9044 130.447 85.1787 130.447Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.691 49.6992V54.0092",
    stroke: "#B2C8F8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.539 51.8594H124.839",
    stroke: "#B2C8F8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4688 85.9219V90.2219",
    stroke: "#B2C8F8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3086 88.0703H52.6186",
    stroke: "#B2C8F8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4414 31.7812V36.0813",
    stroke: "#B2C8F8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2812 33.9297H46.5913",
    stroke: "#B2C8F8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3003 21.7998C91.8416 21.7998 92.2803 21.3611 92.2803 20.8198C92.2803 20.2786 91.8416 19.8398 91.3003 19.8398C90.7591 19.8398 90.3203 20.2786 90.3203 20.8198C90.3203 21.3611 90.7591 21.7998 91.3003 21.7998Z",
    fill: "#ABF1D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9605 117.397C89.5017 117.397 89.9405 116.959 89.9405 116.417C89.9405 115.876 89.5017 115.438 88.9605 115.438C88.4192 115.438 87.9805 115.876 87.9805 116.417C87.9805 116.959 88.4192 117.397 88.9605 117.397Z",
    fill: "#ABF1D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M110.004 26.4757L52.9706 32.3997C51.6687 32.5349 50.7229 33.6999 50.8581 35.0018L58.6583 110.098C58.7935 111.4 59.9586 112.346 61.2605 112.21L118.294 106.286C119.596 106.151 120.541 104.986 120.406 103.684L112.606 28.5882C112.471 27.2862 111.306 26.3405 110.004 26.4757Z",
    fill: "url(#paint1_linear_6178_28808)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.553 29.9399L56.08 35.2864C54.7781 35.4216 53.8323 36.5867 53.9675 37.8886L61.0217 105.803C61.157 107.105 62.322 108.051 63.6239 107.916L115.097 102.569C116.399 102.434 117.345 101.269 117.209 99.967L110.155 32.0524C110.02 30.7505 108.855 29.8047 107.553 29.9399Z",
    fill: "white",
    stroke: "#5DE2C1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 63.8242,
    y: 46.8906,
    width: 39,
    height: 3,
    rx: 1.5,
    transform: "rotate(-6.45958 63.8242 46.8906)",
    fill: "url(#paint2_linear_6178_28808)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 64.8369,
    y: 55.833,
    width: 39,
    height: 3,
    rx: 1.5,
    transform: "rotate(-6.45958 64.8369 55.833)",
    fill: "url(#paint3_linear_6178_28808)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 65.8491,
    y: 64.7764,
    width: 39,
    height: 3,
    rx: 1.5,
    transform: "rotate(-6.45958 65.8491 64.7764)",
    fill: "url(#paint4_linear_6178_28808)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 66.8618,
    y: 73.7188,
    width: 39,
    height: 3,
    rx: 1.5,
    transform: "rotate(-6.45958 66.8618 73.7188)",
    fill: "url(#paint5_linear_6178_28808)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 67.8745,
    y: 82.6621,
    width: 30,
    height: 3,
    rx: 1.5,
    transform: "rotate(-6.45958 67.8745 82.6621)",
    fill: "url(#paint6_linear_6178_28808)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 97.1914,
    y: 92.4258,
    width: 10.9688,
    height: 3,
    rx: 1.5,
    transform: "rotate(-6.45958 97.1914 92.4258)",
    fill: "url(#paint7_linear_6178_28808)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M98.671 33.2706L97.871 25.5706C97.8309 25.251 97.667 24.9599 97.4146 24.7598C97.1622 24.5598 96.8413 24.4667 96.521 24.5006L87.001 25.5006C86.9235 24.7324 86.6955 23.9869 86.3299 23.3068C85.9644 22.6267 85.4684 22.0253 84.8704 21.5368C84.2724 21.0484 83.584 20.6825 82.8446 20.4601C82.1052 20.2377 81.3293 20.1631 80.561 20.2406C79.7928 20.3181 79.0473 20.5461 78.3672 20.9117C77.6871 21.2773 77.0857 21.7732 76.5973 22.3712C75.6108 23.579 75.1445 25.1291 75.301 26.6806L65.751 27.6806C65.5901 27.6969 65.4339 27.7447 65.2915 27.8214C65.1491 27.898 65.0232 28.002 64.921 28.1274C64.8188 28.2528 64.7424 28.3972 64.6961 28.5521C64.6497 28.7071 64.6344 28.8697 64.651 29.0306L65.451 36.7306C65.4673 36.8916 65.5151 37.0477 65.5918 37.1901C65.6684 37.3326 65.7725 37.4585 65.8979 37.5606C66.0232 37.6628 66.1676 37.7393 66.3225 37.7856C66.4775 37.8319 66.6401 37.8472 66.801 37.8306L97.581 34.6306C97.7425 34.6145 97.8992 34.5663 98.0418 34.4889C98.1845 34.4114 98.3103 34.3063 98.4118 34.1796C98.5133 34.053 98.5885 33.9073 98.633 33.7513C98.6775 33.5952 98.6904 33.4318 98.671 33.2706Z",
    fill: "white",
    stroke: "#5DE2C1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 81,
    width: 24,
    height: 24,
    rx: 12,
    fill: "url(#paint8_linear_6178_28808)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M113.176 100.125C113.176 100.125 113.176 100.125 113.926 100.125V100.542C113.926 100.749 113.758 100.917 113.551 100.917C113.344 100.917 113.176 100.749 113.176 100.542V100.125Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M120.031 93.8732C120.928 94.8205 120.928 96.3042 120.031 97.2515L117.94 99.4585C117.2 100.24 116.149 100.586 115.379 100.748C114.98 100.832 114.622 100.874 114.364 100.895C114.235 100.906 114.129 100.911 114.054 100.914C114.016 100.915 113.986 100.916 113.964 100.916L113.938 100.917L113.93 100.917L113.928 100.917L113.927 100.917C113.927 100.917 113.926 100.917 113.926 100.125L113.176 100.125L113.176 100.123L113.176 100.12L113.176 100.112L113.176 100.084C113.176 100.062 113.177 100.03 113.178 99.9901C113.181 99.9108 113.186 99.799 113.196 99.6622C113.216 99.3896 113.256 99.0122 113.335 98.5907C113.489 97.778 113.817 96.6687 114.557 95.8875L116.465 93.8732C117.434 92.8507 119.062 92.8507 120.031 93.8732Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M121.431 93.1122C122.116 93.8352 123.268 93.8352 123.953 93.1122L124.2 92.8509C124.343 92.6997 124.424 92.4998 124.426 92.2916C124.428 91.9589 124.319 91.5442 124.178 91.1853C124.03 90.8108 123.801 90.3786 123.48 90.0398C123.159 89.7009 122.75 89.459 122.395 89.3033C122.055 89.154 121.662 89.0391 121.347 89.0419C121.151 89.0436 120.964 89.125 120.829 89.2675L120.504 89.6103C119.834 90.3178 119.834 91.4258 120.504 92.1332L121.431 93.1122Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.687 88.5766C111.3 88.361 111.776 87.8696 111.971 87.2501L112.338 86.0892C112.402 85.8873 112.589 85.75 112.801 85.75C113.012 85.75 113.2 85.8873 113.264 86.0892L113.63 87.2501C113.826 87.8696 114.301 88.361 114.914 88.5766L115.94 88.9375C116.152 89.0122 116.294 89.2127 116.294 89.4377C116.294 89.6627 116.152 89.8632 115.94 89.9378L114.914 90.2987C114.301 90.5144 113.826 91.0057 113.63 91.6252L113.264 92.7861C113.2 92.9881 113.012 93.1253 112.801 93.1253C112.589 93.1253 112.402 92.9881 112.338 92.7861L111.971 91.6252C111.776 91.0057 111.3 90.5144 110.687 90.2987L109.661 89.9378C109.449 89.8632 109.307 89.6627 109.307 89.4377C109.307 89.2127 109.449 89.0122 109.661 88.9375L110.687 88.5766Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6178_28808",
    x1: 136.585,
    y1: 77.5189,
    x2: 64.8393,
    y2: 77.5189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CEEC3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C93E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6178_28808",
    x1: 112.542,
    y1: 66.4799,
    x2: 74.9781,
    y2: 70.3817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CF2B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C93E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6178_28808",
    x1: 100.325,
    y1: 48.3881,
    x2: 76.5995,
    y2: 48.3881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26890D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C93E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6178_28808",
    x1: 101.338,
    y1: 57.3305,
    x2: 77.6122,
    y2: 57.3305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26890D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C93E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6178_28808",
    x1: 102.35,
    y1: 66.2738,
    x2: 78.6245,
    y2: 66.2739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26890D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C93E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6178_28808",
    x1: 103.363,
    y1: 75.2162,
    x2: 79.6371,
    y2: 75.2162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26890D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C93E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6178_28808",
    x1: 95.9522,
    y1: 84.1596,
    x2: 77.7017,
    y2: 84.1596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26890D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C93E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6178_28808",
    x1: 107.457,
    y1: 93.9233,
    x2: 100.784,
    y2: 93.9233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26890D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C93E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6178_28808",
    x1: 126.462,
    y1: 92.9798,
    x2: 111.862,
    y2: 92.9798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0051FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C93E3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChatIcon);
export default __webpack_public_path__ + "static/media/empty_chat_icon.d5ed16c7f7bc61c8d21b90698a4086de.svg";
export { ForwardRef as ReactComponent };